import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            custom: 1064,
            lg: 1200,
            xl: 1536,
        },
    },
});

export const containerSpacing = { padding: { custom: '110px 14.4444%', xs: '40px 30px' } }

export default theme